<template></template>
<script>
export default {
	name: 'CloMapGooglePath',
	props: {
		google: {
			type: Object,
			required: true,
		},
		map: {
			type: Object,
			required: true,
		},
		path: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {};
	},
	computed: {
		latLngPath() {
			const latLngPath = [];
			for (let i = 0; i < this.path.length; i += 2) {
				latLngPath.push({
					lat: this.path[i + 1],
					lng: this.path[i],
				});
			}
			return latLngPath;
		},
	},
	mounted() {
		new this.google.maps.Polyline({
			path: this.latLngPath,
			map: this.map,
			strokeWeight: 8,
			strokeColor: '#2c75c9',
		});

		const bounds = new this.google.maps.LatLngBounds();
		this.latLngPath.forEach((latLng) => {
			bounds.extend(latLng);
		});
		this.map.fitBounds(bounds);

		//first marker
		new this.google.maps.Marker({
			position: this.latLngPath[0],
			map: this.map,
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				strokeColor: '#2c75c9',
				strokeWeight: 2,
				fillColor: '#ffffff', // $color-white '#ffffff'
				fillOpacity: 1,
				scale: 10,
			},
		});

		//second marker
		new this.google.maps.Marker({
			position: this.latLngPath[this.latLngPath.length - 1],
			map: this.map,
			icon: {
				path: google.maps.SymbolPath.CIRCLE,
				strokeColor: '#ffffff', // $color-white
				strokeWeight: 3,
				fillColor: '#2c75c9',
				fillOpacity: 1,
				scale: 7,
			},
		});
	},
};
</script>

<style></style>
